
(function(window, document, $, undefined) {

    'use strict';
    window.menu = {};

    menu.init = function () {
        menu.mobile();
        menu.cloneBranchWidget();
        menu.toggleAnimations();
        menu.mobileAccessibilty();

        $('.accordion').collapse();

    }

    menu.mobileAccessibilty = function() {

        var $activeTrigger = $('#moby-button');

        $activeTrigger.on('click', function() {

            if (!$activeTrigger.hasClass('is-active')) {
                $activeTrigger.addClass('is-active');
                $activeTrigger.attr("aria-expanded","true");
            } else {
                $activeTrigger.removeClass('is-active');
                $activeTrigger.attr("aria-expanded","false");
            }

        });

        var menuItems = document.querySelectorAll('li.has-submenu');
        Array.prototype.forEach.call(menuItems, function(el, i){
            el.querySelector('a').addEventListener("click",  function(event){
                if (this.parentNode.className == "has-submenu") {
                    this.parentNode.className = "has-submenu open";
                    this.setAttribute('aria-expanded', "false");
                } else {
                    this.parentNode.className = "has-submenu";
                    this.setAttribute('aria-expanded', "true");
                }
                event.preventDefault();
                return false;
            });
        });

    }

    menu.toggleAnimations = function() {

        $('.moby-expand').on('click', function() {
            if ($(this).hasClass('moby-submenu-open')) {
                gsap.to( $(this).find('img'), {duration: .3, rotate: 0, transformOrigin:"50% 50%"});
            } else {
                gsap.to( $(this).find('img'), {duration: .3, rotate: 90, transformOrigin:"50% 50%"});
            }
        });

    }

    menu.cloneBranchWidget = function() {

        let branchWidget = $('.branch-widget').clone().insertAfter( ".moby-menu" ).removeClass().addClass('branch-widget');

        return branchWidget;
    }

    menu.mobile = function () {

        var mobyMenu = new Moby({
            breakpoint		 : 768,
            menu       : $('#mobile-main-navigation'), // The menu that will be cloned
            mobyTrigger: $('#moby-button'), // Button that will trigger the Moby menu to open
            template: '<nav aria-label="Mobile Navigation Dropdown" role="navigation"><div class="moby-wrap">  <div class="moby-menu mt-4 mb-4"> <!-- Must be included --> </div></div></nav>',
            menuClass		 : 'bottom-full fade',
            subMenuOpenIcon  : '<img src="/wp-content/uploads/2020/11/icon-caret.png" width="16" height="22" alt="">',
            subMenuCloseIcon : '<span><img src="/wp-content/uploads/2020/11/icon-caret.png" width="16" height="22"></span>',
            overlay			 : false,
        });

        var searchForm = $('form.search-form').clone().insertAfter('.moby-menu .logo');

        var hamburger = $('.header__navigation');
        var bar_1 = $('.navigation__bar_1');
        var bar_2 = $('.navigation__bar_2');
        var bar_3 = $('.navigation__bar_3');
        var container = $('.site-inner');
        var overlay = $('.site-inner').find('.overlay');
        let tl = gsap.timeline();

        tl
            .to( bar_2, .3, { x: 22, autoAlpha: 0 }, 0)
            .to( bar_1, .3, { width: 37 }, .2)
            .to( bar_3, .3, { width: 37 }, .2)
            .to( bar_1, .3, { y: 8 }, 0)
            .to( bar_3, .3, { y: -10 }, 0)
            .to( bar_1, .3, { rotation: 45, scale: .85, transformOrigin:"center center" }, .3)
            .to( bar_3, .3, { rotation: -45, scale: .85, transformOrigin:"center center" }, .3).reversed(true);

        function toggleDirection() {
            tl.reversed( !tl.reversed() );
        }

        $('#moby-button').click(function(){
            toggleDirection();

            if ($('.header__navigation').hasClass('toggled')) {
                $(this).find('.header__navigation').removeClass('toggled');
                mobyMenu.closeMoby();
            } else {
                $(this).find('.header__navigation').addClass('toggled');
            }

        });


    }

    $(document).on( 'ready', menu.init );

})(window, document, jQuery);